import { render, staticRenderFns } from "./PeriodoModal.vue?vue&type=template&id=3df07420&scoped=true"
import script from "./PeriodoModal.vue?vue&type=script&lang=js"
export * from "./PeriodoModal.vue?vue&type=script&lang=js"
import style0 from "./PeriodoModal.vue?vue&type=style&index=0&id=3df07420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df07420",
  null
  
)

export default component.exports